import { findRoute } from '@/utils/findRoute';

import { DONATION_ROUTES, ROUTES, WEL_MARKET_ROUTES } from './routes';

//* 토스에서 제공하지 않는 서비스 (제품 결정).
const NOT_OFFERED_PREFIXES: readonly string[] = [
  ROUTES.BENEFIT.pathname,
  WEL_MARKET_ROUTES.HOME.pathname,
  ROUTES.RECOMMEND_POLICY_LIST.pathname,
];

//* 토스에서도 웰로 화면을 그대로 쓰는 경로.
const WELLO_PREFIXES: readonly string[] = [
  DONATION_ROUTES.HOME.pathname,
  ROUTES.LOGIN.pathname,
  ROUTES.MY.pathname,
  ROUTES.POINT_MARKET.pathname,
  ROUTES.POINTS.pathname,
  ROUTES.POINT_MARKET_HISTORY.pathname,
  ROUTES.EASY_CERTIFICATION.pathname,
];

const matchesPrefix = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

const toDonationPath = (pathname: string) =>
  `${DONATION_ROUTES.HOME.pathname}${pathname}`;

export const isReachableOnToss = (pathname: string) =>
  !NOT_OFFERED_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix));

export const resolveTossEntry = (
  pathname: string,
): { kind: 'pass' } | { kind: 'redirect'; pathname: string } => {
  if (!WELLO_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix))) {
    return { kind: 'redirect', pathname: toDonationPath(pathname) };
  }

  //* 같은 경로의 고기부 화면이 있으면 그쪽이 정답이다(`/my` → `/donation/my`).
  //* 하위 경로는 대응 화면이 없어 웰로 화면을 그대로 쓴다.
  const donationPath = toDonationPath(pathname);

  return findRoute(donationPath)
    ? { kind: 'redirect', pathname: donationPath }
    : { kind: 'pass' };
};
